<template>
	<div class="bean-cube">
		<div class="bean-cube-list">
			<img v-for="(item, index) in data.beancurdList" :key="index" :src="item.beancurdImg" alt="" @click="handleClick(item)" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	methods: {
		handleClick(item) {
			if (item.beancurdLink) {
				location.href = item.beancurdLink;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.bean-cube {
	margin-bottom: 28px;
	margin-left: 20px;
	&-list {
		display: flex;
		overflow: scroll;
		-webkit-overflow-scrolling: touch;
		flex-shrink: 0;
		img {
			width: 161px;
			height: 113px;
			margin-right: 6px;
			border-radius: 6px;
		}
	}
}
::-webkit-scrollbar {
	width: 0.01rem;
	opacity: 0;
	display: none;
}
</style>